import { Pipe, PipeTransform } from '@angular/core';
import { QuestionSession } from 'src/formio-custom-components/src/lib/custom-component/components/distribute-common-questions/models';

@Pipe({
  name: 'membersLength',
})
export class MembersLengthPipe implements PipeTransform {
  transform(value: QuestionSession[]): number {
    if (!Array.isArray(value) || !value.length) {
      return 0;
    }

    const data = value.reduce((acc, item) => {
      const _item = item.members.split(',');
      return [...acc, ..._item];
    }, []);

    const set = new Set(data);

    return set.size;
  }
}
